import Vue from 'vue';

Vue.component('homepage-showcase-slider', {
    props: {
        cars: {
            type: Array,
        },
    },
    data() {
        return {
            tabIndex: 999,
            homepageCars: null,
            allCars: null,
            activeTooltipIndex: null,
        };
    },

    created() {
        this.allCars = this.cars.sort((a, b) => a.orderNumber - b.orderNumber);
    },

    computed: {
        isLoading: function () {
            return !Boolean(this.homepageCars);
        },
    },

    watch: {
        allCars: function (val) {
            this.homepageCars = val;
        },
    },

    mounted() {
        window.addEventListener('click', this.handleTooltipOutsideClick);
    },

    destroyed() {
        window.removeEventListener('click', this.handleTooltipOutsideClick);
    },

    methods: {
        parseTransformedImage(image) {
            return JSON.parse(image);
        },
        handleShowInternalImageWithLink(car) {
            return (
                car.internalLinkUrl &&
                car.isImageInternalOrProduct === 'internal'
            );
        },

        handleShowProductImageWithLink(car) {
            return car.productUrl && car.isImageInternalOrProduct === 'product';
        },

        switchTab(index, typeFilter) {
            if (index !== 999) {
                this.tabIndex = index;
            }
            if (typeFilter === 'all') {
                this.tabIndex = 999;
                this.homepageCars = this.allCars;
                return;
            }
            this.homepageCars = this.allCars.filter((item) => {
                return item.carType === typeFilter;
            });
        },

        setAllModels() {
            if (this.tabIndex !== 999) {
                this.tabIndex = 999;
            }
            setTimeout(() => this.draggable(), [500]);
        },

        handleCarshowcaseTabActive(index) {
            return index === this.tabIndex
                ? 'carshowcase__tab-title--active'
                : '';
        },

        handleCarTypeColor(typeColor) {
            return `color: ${typeColor}`;
        },

        handleTooltipOutsideClick(event) {
            const tooltip = document.getElementById(
                `tooltip-${this.activeTooltipIndex}`,
            );
            if (!tooltip) return;

            const isClickInsideTooltip = tooltip.contains(event.target);
            const isTooltipActive = typeof this.activeTooltipIndex === 'number';
            if (!isClickInsideTooltip && isTooltipActive) {
                this.activeTooltipIndex = null;
            }
        },

        toggleTooltip(index) {
            if (this.activeTooltipIndex === index) {
                this.activeTooltipIndex = null;
                return;
            }

            this.activeTooltipIndex = index;
        },
    },
});
